// extracted by mini-css-extract-plugin
module.exports = {"wrapBodyModal":"RemoteReleases_wrapBodyModal__2k50H","wrapForMobile":"RemoteReleases_wrapForMobile__3dnPI","table_mobile":"RemoteReleases_table_mobile__2eEaD"};